import PropTypes from 'prop-types';
import { twJoin, twMerge } from 'tailwind-merge';

import Text from 'shopper/components/Text';

import Divider from 'components/Divider';

const DividerWithCenteredText = ({
  children,
  className,
  colorClassName,
  size = 'size2',
}) => (
  <div
    className={twMerge('flex w-full items-center justify-center', className)}
  >
    <Divider className={twJoin('w-full', colorClassName)} />
    <Text className={twJoin('mx-4', colorClassName)} size={size}>
      {children}
    </Text>
    <Divider className={twJoin('w-full', colorClassName)} />
  </div>
);

DividerWithCenteredText.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  colorclassName: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  size: PropTypes.string,
};

export default DividerWithCenteredText;
